import React, { useState, useEffect } from "react";
import "../styles/PixelProfile.css";
import Wishlist from "../comopnents/Wishlist";
import Address from "../comopnents/address";
import Warranty from "../pages/warranty"
import Orders from "../comopnents/orders";
import VerificationList from "./VerificationList";
import { useLocation, useNavigate } from "react-router-dom";
import { becameDealer } from "../services/Tools";
import { showSnackbar } from "../comopnents/snackbar";
import LoadingSpinner from "../comopnents/LoadingSpinner";
import { ResetPassword } from '../services/Auth';
import WarrantyList from "./warrantyList";

const ProfilePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("profile");
  const [loading, setLoading] = useState(false);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [orders, setOrders] = useState([]);
  const [showDealerForm, setShowDealerForm] = useState(false);
  const [gst, setGst] = useState("");
  const [firmName, setFirmName] = useState("");

  const [gstError, setGstError] = useState("");
  const [firmError, setFirmError] = useState("");

  // Add password state
  const [password, setPassword] = useState({
    current: "",
    new: "",
    confirm: ""
  });

  const [passwordLoading, setPasswordLoading] = useState(false);
  const [showPasswords, setShowPasswords] = useState({
    current: false,
    new: false,
    confirm: false
  });

  const { address } = location.state || {};

  // Get user data from localStorage with correct keys
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone: "",
    userId: "",
    gst: "",
    usertype: "",
    firmName: "",
    loginCount: "",
  });

  const userId = localStorage.getItem("userId");

  const validateGST = (value) => {
    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    if (!value) return "GST Number is required";
    if (!gstRegex.test(value)) return "Invalid GST Number format";

    return "";
  };

  const validateFirmName = (value) => {
    if (!value) return "Firm Name is required";
    if (value.length < 3) return "Firm Name must be at least 3 characters";
    return "";
  };

  const handleSubmit = async () => {
    if (!gst || !firmName) {
      alert("Please fill all fields");
      return;
    }

    try {
      const response = await becameDealer({
        id: userId,
        gst: gst,
        firmname: firmName,
      });

      if (response && response[0] === "Update Successfully") {
        showSnackbar("GST Number updated successfully!");
        setShowDealerForm(false);
      } else {
        alert("Error: " + response);
      }
    } catch (error) {
      console.error("Submit error:", error);
      alert("An error occurred while submitting your GST number.");
    }
  };

  useEffect(() => {
    if (location.state?.openTab) {
      setActiveTab(location.state.openTab);
      window.history.replaceState({}, document.title);
    }
  }, []);

  useEffect(() => {
    if (location.state?.openTab) {
      setActiveTab(location.state.openTab);
    }
  }, [location.state]);

  // Fetch user data on component mount
  useEffect(() => {
    fetchUserData();
    fetchOrders();
  }, []);

  const referralfun = () => {
    const referralCode = localStorage.getItem("ReferalCode");

    if (!referralCode) {
      alert("Referral code not available");
      return;
    }

    const signupLink = `${window.location.origin}/SignUp?ref=${referralCode}`;

    const message = `Signup using my referral link:\n${signupLink}`;

    const url = `https://wa.me/?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords(prev => ({
      ...prev,
      [field]: !prev[field]
    }));
  };

  // FIXED: Handle password change
const handlePasswordChange = async (e) => {
  e.preventDefault();

  // Validation
  if (!password.new || !password.confirm) {
    showSnackbar("error", "Please fill all password fields");
    return;
  }

  if (password.new.length < 6) {
    showSnackbar("error", "New password must be at least 6 characters");
    return;
  }

  if (password.new !== password.confirm) {
    showSnackbar("error", "New passwords do not match");
    return;
  }

  setPasswordLoading(true);

  try {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      showSnackbar("error", "User not found. Please login again.");
      return;
    }

    const payload = {
      userid: userId,
      password: password.new,
      password2: password.confirm,
      type: "change password",
    };

    console.log("Sending password change request:", {
      ...payload,
      password: "***",
      password2: "***",
    });

    const response = await ResetPassword(payload);

    console.log("Password change response:", response);
    console.log("Response data:", response?.data);

    // API response:
    // {
    //   msg: "Password Changed Successfully",
    //   status: 200
    // }

    if (
      response?.data?.status === 200 &&
      response?.data?.msg === "Password Changed Successfully"
    ) {
      // SUCCESS
      showSnackbar("success", "Password changed successfully!");

      // Reset form
      setPassword({
        current: "",
        new: "",
        confirm: "",
      });
    } else {
      // API returned an unsuccessful response
      showSnackbar(
        "error",
        response?.data?.msg || "Failed to change password"
      );
    }
  } catch (error) {
    console.error("Password change error:", error);
    console.error("Error response:", error?.response?.data);

    const errorMessage =
      error?.response?.data?.msg ||
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "Failed to change password. Please try again.";

    showSnackbar("error", errorMessage);
  } finally {
    setPasswordLoading(false);
  }
};

  // Fetch user data from localStorage with CORRECT keys
  const fetchUserData = () => {
    setLoading(true);
    try {
      const userData = {
        name:
          localStorage.getItem("firstName") ||
          localStorage.getItem("first_name") ||
          "User",
        email:
          localStorage.getItem("email") ||
          localStorage.getItem("userName") ||
          "",
        phone:
          localStorage.getItem("mobile") ||
          localStorage.getItem("Mobile") ||
          "",
        userId: localStorage.getItem("userId") || "",
        gst: localStorage.getItem("GST") || "Not provided",
        usertype:
          localStorage.getItem("userType") ||
          localStorage.getItem("usertype") ||
          "Customer",
        firmName: localStorage.getItem("firmName") || "",
        loginCount: localStorage.getItem("loginCount") || "0",
      };

      console.log("Fetched user data:", userData);
      setProfile(userData);
     } catch (error) {
      console.error("Error fetching user data:", error);
     } finally {
      setLoading(false);
    }
  };

  // Fetch orders from API
  const fetchOrders = async () => {
    try {
      // Add your orders API call here
      setOrders([]);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  // Update wishlist count
  const updateWishlistCount = (count) => {
    setWishlistCount(count);
  };

  // Logout function
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const renderContent = () => {
    if (loading) {
      return <LoadingSpinner text="Loading profile..." />;
    }

    switch (activeTab) {
      case "wishlist":
        return (
          <div className="content-section">
            <Wishlist />
          </div>
        );

      case "orders":
        return (
          <div className="content-section">
            <Orders />
          </div>
        );
      case "address":
        return (
          <div className="content-section">
            <Address />
          </div>
        );
      case "warranty List":
        return (
          <div className="content-section">
            <WarrantyList  />
          </div>
        );

      case "verificationlist":
        return (
          <div className="content-section">
            <VerificationList />
          </div>
        );

      case "password":
        return (
          <div className="content-section">
            <h2 className="section-title">Change Password</h2>

            <form className="password-form" onSubmit={handlePasswordChange}>
              <div className="form-group">
                {/* <label>Current Password</label>
                <div className="password-input-wrapper">
                  <input
                    type={showPasswords.current ? "text" : "password"}
                    className="form-input"
                    value={password.current}
                    onChange={(e) =>
                      setPassword({ ...password, current: e.target.value })
                    }
                    required
                    minLength="6"
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => togglePasswordVisibility("current")}
                  >
                    {showPasswords.current ? (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      </svg>
                    )}
                  </button>
                </div> */}
              </div>

              <div className="form-group">
                <label>New Password</label>
                <div className="password-input-wrapper">
                  <input
                    type={showPasswords.new ? "text" : "password"}
                    className="form-input"
                    value={password.new}
                    onChange={(e) =>
                      setPassword({ ...password, new: e.target.value })
                    }
                    required
                    minLength="6"
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => togglePasswordVisibility("new")}
                  >
                    {showPasswords.new ? (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 2L22 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        <path d="M6.71277 6.72266C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2714 17.2884" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        <path d="M15.2329 11.2329C15.5538 10.0001 15.2368 8.65691 14.2831 7.70334C13.3295 6.74977 11.9864 6.43278 10.7535 6.7537" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        <path d="M20.6569 18.8767C21.9553 17.5407 22.9999 15.8975 23 12C23 12 19.3636 5 13 5C11.894 5 10.8456 5.21092 9.88855 5.55561" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label>Confirm New Password</label>
                <div className="password-input-wrapper">
                  <input
                    type={showPasswords.confirm ? "text" : "password"}
                    className="form-input"
                    value={password.confirm}
                    onChange={(e) =>
                      setPassword({ ...password, confirm: e.target.value })
                    }
                    required
                    minLength="6"
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => togglePasswordVisibility("confirm")}
                  >
                    {showPasswords.confirm ? (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 2L22 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        <path d="M6.71277 6.72266C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2714 17.2884" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        <path d="M15.2329 11.2329C15.5538 10.0001 15.2368 8.65691 14.2831 7.70334C13.3295 6.74977 11.9864 6.43278 10.7535 6.7537" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        <path d="M20.6569 18.8767C21.9553 17.5407 22.9999 15.8975 23 12C23 12 19.3636 5 13 5C11.894 5 10.8456 5.21092 9.88855 5.55561" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                    )}
                  </button>
                </div>
              </div>

              <div className="form-actions">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={passwordLoading}
                >
                  {passwordLoading ? "Updating..." : "Update Password"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={() =>
                    setPassword({ current: "", new: "", confirm: "" })
                  }
                  disabled={passwordLoading}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        );

      default: // Profile tab
        return (
          <div className="content-section">
            <h2 className="section-title">Profile Details</h2>

            <div className="profile-details">
              <div className="profile-info-card">
                <div className="profile-info-row">
                  <span className="info-label">Full Name:</span>
                  <span className="info-value">{profile.name
                    ? profile.name.charAt(0).toUpperCase() +
                    profile.name.slice(1).toLowerCase()
                    : ""}</span>
                </div>

                <div className="profile-info-row">
                  <span className="info-label">Phone Number:</span>
                  <span className="info-value">
                    {profile.phone || "Not provided"}
                  </span>
                </div>

                <div className="profile-info-row">
                  <span className="info-label">GST Number:</span>
                  <span className="info-value">{profile.gst}</span>
                </div>

                <div className="profile-info-row">
                  <span className="info-label">User Type:</span>
                  <span className="info-value">{profile.usertype}</span>
                </div>

                {profile.firmName && (
                  <div className="profile-info-row">
                    <span className="info-label">Firm Name:</span>
                    <span className="info-value">{profile.firmName}</span>
                  </div>
                )}

                <div className="profile-info-row">
                  <span className="info-label">User Code</span>
                  <span className="info-value">{localStorage.getItem('ReferalCode')}</span>
                </div>

                {/* Become Dealer Section */}
                {profile.usertype !== "Dealer" && (
                  <div className="dealer-section">
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={showDealerForm}
                        onChange={() => setShowDealerForm(!showDealerForm)}
                        style={{
                          width: "16px",
                          height: "16px",
                          cursor: "pointer",
                        }}
                      />
                      <span style={{ fontSize: "15px" }}>
                        Want to Become Dealer
                      </span>
                    </label>

                    {showDealerForm && (
                      <div className="dealer-form">
                        <div className="form-group">
                          <label>GST Number</label>
                          <input
                            type="text"
                            value={gst}
                            placeholder="Enter GST Number"
                            onChange={(e) => {
                              const value = e.target.value.toUpperCase();
                              setGst(value);
                              setGstError(validateGST(value));
                            }}
                          />
                          {gstError && <p className="error-text">{gstError}</p>}
                        </div>

                        <div className="form-group">
                          <label>Firm Name</label>
                          <input
                            type="text"
                            value={firmName}
                            placeholder="Enter Firm Name"
                            onChange={(e) => {
                              const value = e.target.value.toUpperCase();
                              setFirmName(value);
                              setFirmError(validateFirmName(value));
                            }}
                          />
                          {firmError && (
                            <p className="error-text">{firmError}</p>
                          )}
                        </div>

                        <button
                          className="btn btn-primary"
                          onClick={handleSubmit}
                          disabled={!!gstError || !!firmError}
                        >
                          Submit
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20 }}>
                <button style={{ marginTop: 10 }}
                  className="btn btn-primary"
                  onClick={referralfun}
                >
                  Refer to earn
                </button>
                {/* <h4 style={{ marginTop: 10, color: 'black' }}>{localStorage.getItem('ReferalCode')}</h4> */}
              </div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="profile-page">
      <div className="profile-header">
        <h1>My Account</h1>
        <p>Manage your account settings and preferences</p>
      </div>

      <div className="profile-container">
        <div className="profile-sidebar">
          <div className="user-info">
            <div className="user-details">
              <h3>
                {profile.name
                  ? profile.name.charAt(0).toUpperCase() +
                  profile.name.slice(1).toLowerCase()
                  : ""}
              </h3>              <p>{profile.email}</p>
              <p style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
                Mobile: {profile.phone || "Not provided"}
              </p>
            </div>
          </div>

          <nav
            className="profile-nav userinfo"
            style={{ width: "100%", marginLeft: "0px" }}
          >
            <button
              className={`nav-link ${activeTab === "profile" ? "active" : ""}`}
              onClick={() => setActiveTab("profile")}
            >
              <span className="nav-icon"></span>
              Profile Details
            </button>

            <button
              className={`nav-link ${activeTab === "wishlist" ? "active" : ""}`}
              onClick={() => setActiveTab("wishlist")}
            >
              <span className="nav-icon"></span>
              My Wishlist
              {wishlistCount > 0 && (
                <span className="nav-badge">{wishlistCount}</span>
              )}
            </button>

            <button
              className={`nav-link ${activeTab === "orders" ? "active" : ""}`}
              onClick={() => setActiveTab("orders")}
            >
              <span className="nav-icon"></span>
              My Orders
              {orders.length > 0 && (
                <span className="nav-badge">{orders.length}</span>
              )}
            </button>

            <button
              className={`nav-link ${activeTab === "address" ? "active" : ""}`}
              onClick={() => setActiveTab("address")}
            >
              <span className="nav-icon"></span>
              My Addresses
            </button>

            <button
              className={`nav-link ${activeTab === "warranty List" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("warranty List");
                window.scrollTo(0, 0);
              }}
            >
              <span className="nav-icon"></span>
              Warranty List
            </button>

            {/* FIXED: Verification List button */}
            <button
              className={`nav-link ${activeTab === "verificationlist" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("verificationlist");
                window.scrollTo(0, 0);
              }}
            >
              <span className="nav-icon"></span>
              Verification List
            </button>

            <button
              className={`nav-link ${activeTab === "password" ? "active" : ""}`}
              onClick={() => setActiveTab("password")}
            >
              <span className="nav-icon"></span>
              Change Password
            </button>
          </nav>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button
              onClick={handleLogout}
              style={{
                padding: "5px 85px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#005487",
                backgroundColor: "#ffffff",
                border: "2px solid #005487",
                borderRadius: "8px",
                cursor: "pointer",
                marginTop: "15px",
              }}
            >
              Logout
            </button>
          </div>
        </div>

        <div className="profile-content">{renderContent()}</div>
      </div>
    </div>
  );
};

export default ProfilePage;